import { apiInstance } from '@/data/api/api.config';
import { toPlatforms } from '@/data/dto/platform.dto';
import { Platform, PlatformsResponse } from '@/data/models/platform.interface';

class PlatformService {
  public async getPlatforms(): Promise<Platform[]> {
    const response = await apiInstance.get<PlatformsResponse>(`/v1/platform`);

    if (!response.data || !Array.isArray(response.data.data)) {
      throw new Error('Invalid response format for platforms');
    }

    return toPlatforms(response.data.data || []);
  }
}

export default new PlatformService();
